import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import KobooTextField from '../Layout/KobooTextField.jsx';
import KobooButton from '../Layout/KobooButton';
import { getRenters } from '../../store/renters/actions';
import { getSites, putSite } from '../../store/sites/actions';
import Spinner from '../Layout/Spinner';
import defaultStyles from '../../constants/stylesDefault';
import Loader from '../Layout/Loader';
import { SITES } from '../../constants/routes';
import StandTable from '../Stand/StandTable';
import { ROLE_USER } from '../../constants/roles';
import SiteSlot from './SiteSlot';
import { handleError } from '../../store/infos/actions';
import { getLongLocationTypes } from '../../store/longLocationDurations/actions';
import { SiteBusinessHours } from './SiteBusinessHours';
import defaultBusinessHours from '../../constants/defaultBusinessHours';
import SiteLongLocationDuration from './SiteLongLocationDuration';
import SiteTypeSelect from './SiteTypeSelect';
import { Checkbox, FormControlLabel } from '@material-ui/core';

const styles = () => (
  {
    listItem: {
      display: 'flex',
    },
    day: {
      width: 100,
    },
    businessHoursSwitch: {
      marginRight: 30,
    },
    timePicker: {
      maxWidth: 150,
      margin: '0px 30px',
    },
    afternoonTime: {
      marginLeft: 40,
      display: 'flex',
    },
  }
);

const byPropKey = (propertyName, value) => () => (
  {
    [propertyName]: value,
  }
);

const computeSlots = (slots) => {
  let computedSlots = JSON.parse(JSON.stringify(slots));
  computedSlots.forEach((slot) => {
    slot.price = slot.price / 100;
  });
  return computedSlots;
};

const getStateBySiteInfo = siteInfo => (
  {
    number: siteInfo.number || '',
    name: siteInfo.name || '',
    email: siteInfo.email || '',
    phone: siteInfo.phone || '',
    latitude: siteInfo.latitude || '',
    longitude: siteInfo.longitude || '',
    radius: siteInfo.radius || '',
    caution: siteInfo.caution
      ? siteInfo.caution / 100
      : '',
    turnover: siteInfo.turnover
      ? siteInfo.turnover / 100 + ' €'
      : '0 €',
    slots: siteInfo.slots
      ? computeSlots(siteInfo.slots)
      : [],
    type: siteInfo.type || 0,
    description: siteInfo.description || '',
    isBookable: siteInfo.is_bookable || false,
    isOpenAllTime: siteInfo.is_open_all_time || false,
    isFreeBooking: siteInfo.is_free_booking || false,
    businessHours: siteInfo.business_hours.length > 0
      ? siteInfo.business_hours
      : defaultBusinessHours,
    longLocationDurations: siteInfo.long_location_durations.filter(elem => {
      return elem.is_enabled === true;
    }).map(lld => {
      let multiplicator = 100 * lld.long_location_type.count;
      if (lld.long_location_type.type === 'year') {
        multiplicator = multiplicator * 12;
      }
      return {
        ...lld,
        mechanical_price: lld.mechanical_price
          ? lld.mechanical_price / multiplicator
          : '',
        electric_price: lld.electric_price
          ? lld.electric_price / multiplicator
          : '',
      };
    }),
  }
);

const findSite = (sites, site_id, history) => {
  const foundSite = sites.find(site => (
    site.id === site_id
  ));
  if (foundSite === undefined) {
    history.push('/notFound');
  }
  return foundSite;
};

const INITIAL_STATE = {
  renter_id: '',
  number: '',
  name: '',
  email: '',
  phone: '',
  latitude: '',
  longitude: '',
  radius: '',
  caution: '',
  turnover: '',
  description: '',
  slots: [],
  error: null,
  type: 0,
  refreshedSites: false,
  isBookable: false,
  isOpenAllTime: false,
  isFreeBooking: false,
  businessHours: [],
  longLocationDurations: [],
  longLocationDurationsToRemove: [],
};

export class EditSiteForm extends Component {
  static propTypes = {
    authUser: PropTypes.object,
    match: PropTypes.object.isRequired,
  };

  state = {
    site_id: this.props.match.params.siteId,
    ...INITIAL_STATE,
  };

  static getDerivedStateFromProps(props, state) {
    let newState = null;
    if (props.authUser && props.roles) {
      const role = props.roles[props.authUser.uid];
      newState = {
        ...newState,
        role: role,
      };
      if ((
        !state.refreshedSites || !props.sites
      ) && !props.pendingSites && !props.errorSites) {
        props.getSites(props.authUser.ma, role);
        newState = {
          ...newState,
          refreshedSites: true,
          longLocationDurationsToRemove: [],
        };
      }
      if (!props.renters && !props.pendingRenters && !props.errorRenters) {
        props.getRenters(props.authUser.ma, role);
      }
      if (!props.llts.content && !props.llts.pending && !props.llts.error) {
        props.getLongLocationTypes(props.authUser.ma);
      }
      if (!state.renter_name && props.sites && props.renters) {
        const site = findSite(props.sites, state.site_id, props.history);
        newState = { ...newState, ...getStateBySiteInfo(site) };
        const foundRenter = props.renters.find(renter => (
          renter.id === site.renter_info_id
        ));
        newState = {
          ...newState,
          renter_name: foundRenter.name,
        };
      }
    }
    return newState;
  }

  checkTime = (businessHours) => {
    let businessHoursError = [];
    businessHours.forEach(businessHour => {
      if (
        (
          !businessHour.is_continuous_day &&
          (
            businessHour.morning_start >= businessHour.morning_end ||
            businessHour.morning_end >= businessHour.afternoon_start ||
            businessHour.afternoon_start >= businessHour.afternoon_end
          )
        ) ||
        (
          businessHour.is_continuous_day && businessHour.morning_start >= businessHour.morning_end
        )
      ) {
        businessHoursError.push(
          'Certains horaires commencent avant que ceux d\'avant ne se terminent',
        );
      }
    });
    return businessHoursError;
  };

  onSubmit = (event) => {
    const {
      renter_id,
      number,
      name,
      email,
      phone,
      latitude,
      longitude,
      radius,
      caution,
      description,
      slots,
      type,
      isOpenAllTime,
      businessHours,
      isBookable,
      longLocationDurations,
      longLocationDurationsToRemove,
      isFreeBooking,
    } = this.state;
    let errorBusinessHours = this.checkTime(businessHours);
    let emptySlot = slots.find(slot => slot.time === 0);
    if (errorBusinessHours.length > 0) {
      this.props.handleError({ message: errorBusinessHours[0] });
    } else if (emptySlot) {
      this.props.handleError({ message: 'Tous les créneaux doivent avoir une durée.' });
    } else {
      slots.forEach((slot) => {
        slot.price = slot.price * 100;
      });
      this.props.putSite(
        this.props.authUser.ma,
        ROLE_USER,
        this.state.site_id,
        {
          renter_info_id: renter_id,
          number: number || null,
          name,
          email,
          phone,
          latitude,
          longitude,
          radius,
          caution: caution * 100,
          description,
          slots,
          type: type,
          is_open_all_time: isOpenAllTime,
          business_hours: businessHours,
          is_bookable: isBookable,
          is_free_booking: isFreeBooking,
          long_location_durations: longLocationDurations.map(elem => {
            // caution you pass price for one month
            return {
              ...elem,
              mechanical_price: elem.mechanical_price !== ''
                ? elem.mechanical_price
                : null,
              electric_price: elem.electric_price !== ''
                ? elem.electric_price
                : null,
            };
          }),
          long_location_durations_to_remove: longLocationDurationsToRemove,
        },
      )
        .then(value => {
          if (value) {
            this.props.history.push(SITES);
          }
        });
    }
    event.preventDefault();
  };

  handleChangeType = event => {
    this.setState({ type: event.target.value });
    if (event.target.value === 5) {
      this.setState({ isBookable: true, isFreeBooking: false });
    }
  };

  handleChangeIsBookable = () => {
    this.setState({ isBookable: !this.state.isBookable });
  };
  handleChangeIsFreeBooking = () => {
    this.setState({ isFreeBooking: !this.state.isFreeBooking });
  };
  handleAddSlot = () => {
    let slot = {
      price: 0,
      time: 0,
      position: this.state.slots.length + 1,
    };
    this.state.slots.push(slot);
    this.setState({ slots: this.state.slots });

  };

  handleRemoveSlot = () => {
    this.state.slots.pop();
    this.setState({ slots: this.state.slots });
  };

  onChangeSlotPrice = (price, index) => {
    this.setState(({ slots }) => (
      {
        slots: [
          ...slots.slice(0, index),
          {
            ...slots[index],
            price: parseFloat(price),
          },
          ...slots.slice(index + 1),
        ],
      }
    ));
  };

  onChangeSlotTime = (time, index) => {
    this.setState(({ slots }) => (
      {
        slots: [
          ...slots.slice(0, index),
          {
            ...slots[index],
            time: parseInt(time, 10),
          },
          ...slots.slice(index + 1),
        ],
      }
    ));
  };

  handleSwitchIsOpenAllTime = event => {
    this.setState({ isOpenAllTime: event.target.checked });
  };

  handleSwitch = (event, businessHour, name) => {
    event.persist();
    const businessHourIndex = this.state.businessHours.findIndex(b => b.day === businessHour.day);
    this.setState(({ businessHours }) => (
      {
        businessHours: [
          ...businessHours.slice(0, businessHourIndex),
          {
            ...businessHours[businessHourIndex],
            [name]: event.target.checked,
          },
          ...businessHours.slice(businessHourIndex + 1),
        ],
      }
    ));
  };

  handleChangeTime = (event, businessHour, name) => {
    event.persist();
    const businessHourIndex = this.state.businessHours.findIndex(b => b.day === businessHour.day);
    this.setState(({ businessHours }) => (
      {
        businessHours: [
          ...businessHours.slice(0, businessHourIndex),
          {
            ...businessHours[businessHourIndex],
            [name]: event.target.value,
          },
          ...businessHours.slice(businessHourIndex + 1),
        ],
      }
    ));
  };

  handleAddLongLocationDuration = () => {
    if (this.props.llts.content.length > 0) {
      const firstLlt = this.props.llts.content[0];
      let currentLlds = [...this.state.longLocationDurations];
      const newLld = {
        'id': Math.floor(Math.random() * 1000).toString(),
        'is_enabled': true,
        'is_mechanical_available': false,
        'mechanical_price': '',
        'is_electric_available': false,
        'electric_price': '',
        'long_location_type': { ...firstLlt },
      };
      currentLlds.push(newLld);
      this.setState({ longLocationDurations: currentLlds });
    }
  };

  handleEditLongLocationDuration = (lld, property) => {
    let currentLlds = [...this.state.longLocationDurations];
    const indexLld = currentLlds.findIndex(elem => elem.id === lld.id);
    if (indexLld >= 0) {
      let newLld = { ...lld };
      switch (property) {
        case 'electric_price':
          newLld.is_electric_available = lld.electric_price !== '';
          newLld.electric_price = lld.electric_price !== '' ? parseInt(lld.electric_price) : '';
          break;
        case 'mechanical_price':
          newLld.is_mechanical_available = lld.mechanical_price !== '';
          newLld.mechanical_price = lld.mechanical_price !== ''
            ? parseInt(lld.mechanical_price)
            : '';
          break;
        case 'llt':
          newLld.long_location_type = this.props.llts.content.find(elem =>
            elem.id === lld.long_location_type.id,
          );
          break;
      }

      currentLlds.splice(indexLld, 1, newLld);
      this.setState({ longLocationDurations: currentLlds });
    }
  };

  handleRemoveLongLocationDuration = (lldId) => {
    let currentLlds = [...this.state.longLocationDurations];
    const indexLld = currentLlds.findIndex(elem => elem.id === lldId);
    if (indexLld >= 0) {
      currentLlds.splice(indexLld, 1);
      this.setState({
        longLocationDurations: currentLlds,
        longLocationDurationsToRemove: [...this.state.longLocationDurationsToRemove, lldId],
      });
    }
  };

  render() {
    const {
      renter_name,
      number,
      name,
      email,
      phone,
      latitude,
      longitude,
      radius,
      caution,
      turnover,
      description,
      slots,
      type,
      isOpenAllTime,
      businessHours,
      isBookable,
      longLocationDurations,
      isFreeBooking,
    } = this.state;

    const {
      sites,
      pending,
      classes,
    } = this.props;

    const renderGeneralInfos =
      <Grid container style={defaultStyles.media}>
        <Grid item xs={12} sm={12} md={12}>
          <Typography
            align="left"
            variant="h6"
            gutterBottom
          >
            Informations Générales
          </Typography>
        </Grid>
        <SiteTypeSelect type={type} handleChangeType={this.handleChangeType} />

        <Grid item xs={12} sm={12} md={4}>
          <FormControlLabel
            style={{
              marginLeft: 0,
              marginRight: '8px',
              marginTop: '25px',
              marginBottom: 0,
            }}
            control={
              <Checkbox
                checked={isBookable}
                onChange={this.handleChangeIsBookable}
                name="isBookableCheckbox"
                color="primary"
                disabled={type === 5}
              />
            }
            label="Station réservable"
          />
        </Grid>
        <Grid item xs={12} sm={12} md={4}>
          <FormControlLabel
            style={{
              marginLeft: 0,
              marginRight: '8px',
              marginTop: '25px',
              marginBottom: 0,
            }}
            control={
              <Checkbox
                checked={isFreeBooking}
                onChange={this.handleChangeIsFreeBooking}
                name="isFreeBooking"
                color="primary"
                disabled={type === 5}
              />
            }
            label="Location gratuite"
          />
        </Grid>
        <KobooTextField
          label="Numéro"
          id="number"
          onChange={event => this.setState(byPropKey('number', event.target.value))}
          value={number}
        />
        <KobooTextField
          label="Nom"
          id="name"
          onChange={event => this.setState(byPropKey('name', event.target.value))}
          value={name}
          required
        />
        <KobooTextField
          label="Mail"
          id="email"
          onChange={event => this.setState(byPropKey('email', event.target.value))}
          value={email}
        />
        <KobooTextField
          label="Téléphone"
          id="phone"
          onChange={event => this.setState(byPropKey('phone', event.target.value))}
          value={phone}
        />
        <KobooTextField
          label="Latitude"
          id="latitude"
          onChange={event => this.setState(byPropKey('latitude', event.target.value))}
          value={latitude}
          required
        />
        <KobooTextField
          label="Longitude"
          id="longitude"
          onChange={event => this.setState(byPropKey('longitude', event.target.value))}
          value={longitude}
          required
        />
        <KobooTextField
          label="Rayon en mètre"
          id="radius"
          onChange={event => this.setState(byPropKey('radius', event.target.value))}
          value={radius}
          required
        />
        <KobooTextField
          label="Caution en €"
          id="caution"
          onChange={event => this.setState(byPropKey('caution', event.target.value))}
          value={caution}
          required
        />
        <KobooTextField
          label="Description"
          id="description"
          onChange={event => this.setState(byPropKey('description', event.target.value))}
          value={description}
        />
      </Grid>;

    const renderSlots =
      <Grid container style={defaultStyles.media}>
        <Grid item xs={12} sm={12} md={12}>
          <Typography
            align="left"
            variant="h6"
            gutterBottom
          >
            Tarifs de location (en minutes)
          </Typography>
          {slots.map((slot, index) => {
            let time = slots.slice(0, index)
              .map(slot => slot.time).reduce((prev, next) => {
                return prev + next;
              }, 0);
            let price = slots.slice(0, index + 1)
              .map(slot => slot.price).reduce((prev, next) => prev + next);
            return <SiteSlot
              slot={slot}
              index={index}
              cumulateTime={time}
              cumulatePrice={price}
              onChangePrice={this.onChangeSlotPrice}
              onChangeTime={this.onChangeSlotTime}
              isLast={index + 1 === slots.length}
              onAdd={this.handleAddSlot}
              onRemove={this.handleRemoveSlot}
            />;
          })}
        </Grid>
      </Grid>;

    const renderStands =
      <Grid container style={defaultStyles.media}>
        <Grid item xs={12} sm={12} md={12}>
          <Typography
            align="left"
            variant="h6"
            gutterBottom
          >
            Bornes
          </Typography>
        </Grid>
        <StandTable
          sites={sites}
          site_id={this.state.site_id}
        />
      </Grid>;

    if (pending) {
      return (
        <Loader />
      );
    } else if (sites && sites.length) {
      return (
        <form onSubmit={this.onSubmit} style={defaultStyles.center}>
          <Grid item xs={12} sm={12} md={12}>
            <Typography
              color="primary"
              align="left"
              variant="h5"
              gutterBottom
            >
              Loueur: {renter_name} - Chiffre d'affaire : {turnover}
            </Typography>
          </Grid>
          {renderGeneralInfos}
          <br />
          {renderSlots}
          <br />
          {(
            type !== 0 && type !== 3 && type !== 4
          ) && renderStands}
          <br />
          <SiteBusinessHours
            businessHours={businessHours}
            isOpenAllTime={isOpenAllTime}
            onChangeTime={this.handleChangeTime}
            onSwitch={this.handleSwitch}
            onSwitchIsOpenAllTime={this.handleSwitchIsOpenAllTime}
            classes={classes}
          />
          <br />
          {type === 5 && <SiteLongLocationDuration
            longLocationTypes={this.props.llts.content || []}
            longLocationDurations={longLocationDurations}
            handleAddLongLocationDuration={this.handleAddLongLocationDuration}
            handleRemoveLongLocationDuration={this.handleRemoveLongLocationDuration}
            handleEditLongLocationDuration={this.handleEditLongLocationDuration}
          />}
          <br />
          <KobooButton disabled={this.props.sending} type="submit">
            {this.props.sending
              ?
              <Spinner
                style={{
                  parent: { margin: '4px auto 0' },
                  child: {},
                }}
              />
              : 'Modifier'}
          </KobooButton>
        </form>
      );
    }
    return (
      <Loader />
    );
  }
}

function mapStateToProps(state) {
  return {
    roles: state.roles.content,
    authUser: state.users.authUser,
    renters: state.renters.content,
    sites: state.sites.content,
    pendingRenters: state.renters.pending,
    pendingSites: state.sites.pending,
    errorRenters: state.renters.error,
    errorSites: state.sites.error,
    pending: state.renters.pending || state.sites.pending,
    sending: state.sites.sending,
    llts: state.llts,
  };
}

export default compose(
  withStyles(styles),
  connect(mapStateToProps, {
    putSite,
    getRenters,
    getSites,
    handleError,
    getLongLocationTypes,
  }),
)(EditSiteForm);



// WEBPACK FOOTER //
// ./src/components/Site/EditSiteForm.jsx